
var saleCalculator = require('./saleCalculator');
var constants = require('../../domain/constants.js');
var stringUtil = require('../../string/stringUtil.js');
var storefrontUtility = require('../../domain/storefrontUtility');
var staffUtility = require('../staff/staffUtility');
var formatter = require('../../formatter/formatter');
var localizationUtils = require('../../domain/localizationUtils');
var controlSettingsUtils = require('../../domain/settings/controlSettingsUtils');
var businessDateUtil = require('../../dateUtil/businessDateUtil');
var commonUtility = require('../commonUtility');
var dateUtil = require('../../dateUtil/dateUtil');

module.exports.isCancelled = function(sale)
{
    return sale.isCancelled == true;
}

module.exports.canCancelSale = function(sale)
{
    return !sale.isCancelled;
}

module.exports.isExistingSale = function(saleContext)
{
    return saleContext.isExistingSale;
}


module.exports.isExistingSaleItem = function(saleContext, saleItem)
{
    //Todo::
    return !saleItem.isNewItem;
}

module.exports.canExitSale = function(saleContext)
{
    let sale = saleContext.sale;

    /*
        If sale is cancelled or is an existing sale then 
        user can exit from screen.
    */
    if (sale.isCancelled || this.isExistingSale(saleContext))
        return true;

    /*
        if sale is not existing sale and have no items then he cannot exit.
    */
    if (sale.saleItems == null || sale.saleItems.length <= 0)
        return false;

    /*
        If there is any pending payable, he cannot exit.
    */    
    if (saleCalculator.isSalePartiallyOrFullyPaid(sale) &&  !saleCalculator.isSaleFullyPaid(sale))
        return false;

    /*
        if property allows unpaid sale for dispatch type, he can exit,
    */
    if (!saleCalculator.isSaleFullyPaid(sale) && !this.canPlaceOrderWithOutPayment(sale))
        return false;

    return true;
}

module.exports.canEditSale = function(saleContext)
{
    let sale = saleContext.sale;

    if (sale.isCancelled)
        return false;

    if (sale.paymentMethod == constants.PaymentMethodVenuePaid  && !this.isExistingSale(saleContext))
        return true;

    if (saleCalculator.isSalePartiallyOrFullyPaid(sale))
        return false;

    if (this.isExistingSale(saleContext) && saleCalculator.calculateRemainingPayableAmount(sale) <= constants.numericThresholdValue)
        return false;
        
    return true;
}

module.exports.canEnterNotes = function(sale)
{
    if (sale.isCancelled || 
        !this.isTodaysBusinessDateSale(sale) || 
        !stringUtil.isStringNullOrEmpty(sale.actualDispatchDateTime) || 
        !stringUtil.isStringNullOrEmpty(sale.finalStationCompletionDateTime))
        return false;

    return true;
}

module.exports.canAssociateCustomer = function(saleContext)
{

    let sale = saleContext.sale;
    if (sale.saleType != constants.SaleTypeSale || 
        sale.venueCode != constants.VenueCodeProperty ||
        !this.canEditSale(saleContext))
        return false;

    return  saleContext.customerContext != null || stringUtil.isStringNullOrEmpty(sale.customerId);
}

module.exports.canIssueDiscount = function(saleContext)
{
    let sale = saleContext.sale;

    if (!this.canEditSale(saleContext) ||
        !this.isTodaysBusinessDateSale(sale) ||
        sale.saleType != constants.SaleTypeSale ||
        sale.venueCode != constants.VenueCodeProperty
        )
        return false;

    return true;
}

module.exports.canChangeTable = function(saleContext)
{
    let sale = saleContext.sale;
    let storefront = storefrontUtility.getStorefrontById(sale.storefrontId);
    
    if (!this.canEditSale(saleContext) ||
        !this.isTodaysBusinessDateSale(sale) ||
        sale.dispatchType != constants.DispatchTypeDineIn ||
        storefront == null ||
        storefrontUtility.getStorefrontVenueCode(storefront) != constants.VenueCodeProperty ||
        !storefrontUtility.canHaveTableAssignment(storefront))
        return false;

    return true;
}

module.exports.canChangePagerNumber = function(saleContext)
{
    let sale = saleContext.sale;
    let storefront = storefrontUtility.getStorefrontById(sale.storefrontId);
    
    if (!this.canEditSale(saleContext) ||
        !this.isTodaysBusinessDateSale(sale) ||
        sale.dispatchType != constants.DispatchTypeTakeAway ||
        storefront == null ||
        storefrontUtility.getStorefrontVenueCode(storefront) != constants.VenueCodeProperty ||
        !storefrontUtility.canHavePagerNumber(storefront))
        return false;

    return true;
}

module.exports.canAssociateDriver = function(sale)
{
    let storefront = storefrontUtility.getStorefrontById(sale.storefrontId);

    if (sale.isCancelled || 
        !this.isTodaysBusinessDateSale(sale) || 
        sale.saleType != constants.SaleTypeSale ||
        sale.dispatchType != constants.DispatchTypeDelivery ||
        storefront == null || 
        storefront.operatingConfiguration == null ||
        !storefront.operatingConfiguration.propertyHandlesDelivery)
        return false;

    return true;
}

module.exports.canAddTimes = function(sale)
{
    if (sale.isCancelled || 
        sale.saleType != constants.SaleTypeSale ||
        !this.isTodaysBusinessDateSale(sale) || 
        !stringUtil.isStringNullOrEmpty(sale.actualDispatchDateTime) || 
        !stringUtil.isStringNullOrEmpty(sale.finalStationCompletionDateTime))
        return false;

    return true;
}

module.exports.canChangeMenu = function(saleContext)
{
    let sale = saleContext.sale;
    let saleStorefront = storefrontUtility.getStorefrontById(sale.storefrontId);
    let posStorefronts = storefrontUtility.getPOSStorefronts();

    if (!this.canEditSale(saleContext) ||
        !this.isTodaysBusinessDateSale(sale) ||
        !controlSettingsUtils.getAllowItemsFromMultipleStorefronts() ||
        sale.saleType != constants.SaleTypeSale ||
        saleStorefront.type != constants.storefrontTypes.POS ||
        posStorefronts.length <= 1 ||
        posStorefronts.find(p => stringUtil.areStringSame(p.id, sale.storefrontId) == null))
        return false;

    return true;
}

module.exports.canHaveOpenItems = function(saleContext)
{
    let sale = saleContext.sale;

    if (!this.canEditSale(saleContext) ||
        !this.isTodaysBusinessDateSale(sale) ||
        sale.saleType != constants.SaleTypeSale ||
        !controlSettingsUtils.getAllowOpenItems())
        return false;

    return true;
}

module.exports.canChangeDispatchType = function(saleContext)
{
    let sale = saleContext.sale;
    let saleStorefront = storefrontUtility.getStorefrontById(sale.storefrontId);

    if (this.isExistingSale(saleContext) ||
        !this.canEditSale(saleContext) ||
        !this.isTodaysBusinessDateSale(sale) ||
        sale.saleType != constants.SaleTypeSale ||
        storefrontUtility.getStorefrontVenueCode(saleStorefront) != constants.VenueCodeProperty)
        return false;

    return true;
}



module.exports.canHoldUnHoldSale = function (saleContext)
{
    let sale = saleContext.sale;

    if(sale.isCancelled)
        return false;

    if (stringUtil.areStringSame(sale.saleType, constants.SaleTypeSale))
    {
        return !stringUtil.areStringSame(sale.dispatchType, constants.DispatchTypeDineIn) && 
               !this.isExistingSale(saleContext) &&
               !saleCalculator.isSalePartiallyOrFullyPaid(sale);
    }

    if (this.isSaleHoldByStaff(sale))
    {
        return true;
    }

    return false;
}

module.exports.canSaleBePaidOverThePhone = function (sale)
{
    
    if (this.isCancelled(sale))
        return false;

    if(saleCalculator.isSalePartiallyOrFullyPaid(sale))
        return false;

    if(!storefrontUtility.isStorefrontEnableForPayOverPhone(sale.storefrontId))
        return false;


    if(stringUtil.isStringNullOrEmpty(sale.customerId) || stringUtil.isStringNullOrEmpty(sale.dispatchInfo))
        return false;

    const dispatchInfo = JSON.parse(sale.dispatchInfo);
    if(stringUtil.isStringNullOrEmpty(dispatchInfo.customerPhoneNumber))
        return false;

    return true;
}

module.exports.canDiscard = function (sale)
{
    return !saleCalculator.isSalePartiallyOrFullyPaid(sale)
}

module.exports.isSaleHoldByStaff = function (sale)
{
    return stringUtil.areStringSame(sale.saleType, constants.SaleTypeHold) && 
            stringUtil.areStringSame(sale.holdReasonCode, constants.holdReasonCode.staff);
}


module.exports.isSaleHoldByPaymentOverPhone = function (sale)
{
    return stringUtil.areStringSame(sale.saleType, constants.SaleTypeHold) && 
            stringUtil.areStringSame(sale.holdReasonCode, constants.holdReasonCode.paymentByPhone);
}

module.exports.isSaleHold = function (sale)
{
    return this.isSaleHoldByStaff(sale) || this.isSaleHoldByPaymentOverPhone(sale);
}

module.exports.canPlaceOrderWithOutPayment = function(sale)
{
    if (this.isSaleHold(sale))
        return true;

    const storefrontOperatingConfiguration = storefrontUtility.getCurrentStorefront().operatingConfiguration;
    if(storefrontOperatingConfiguration == null || storefrontOperatingConfiguration.unpaidDispatchTypes == null)
        return false;
    return storefrontOperatingConfiguration.unpaidDispatchTypes.includes(sale.dispatchType);
}

module.exports.markItemAsRefunded = function(saleItem, refundCode)
{
    if (saleItem.isRefunded)
        return;

    saleItem.isRefunded = true;
    saleItem.refundCode = refundCode;
    saleItem.saleItems.forEach (childSaleItem =>
    {
        this.markItemAsRefunded(childSaleItem, refundCode);
    });
}

module.exports.markItemAsCompliment = function(saleItem, complimentReason)
{
    if (saleItem.isComplimented)
        return;

    saleItem.isComplimented = true;
    saleItem.complimentedBy = staffUtility.getLoginStaffCompleteName();
    saleItem.complimentReason = complimentReason;
    saleItem.originalUnitPrice = saleItem.unitPrice;
    saleItem.originalVat = saleItem.vat;

    saleItem.unitPrice = 0;
    saleItem.vat = 0; 

    saleItem.saleItems.forEach (childSaleItem =>
    {
        this.markItemAsCompliment(childSaleItem, complimentReason);
    });
}

module.exports.revertItemAsCompliment = function(saleItem)
{
    if (!saleItem.isComplimented)
        return;

    saleItem.isComplimented = false;
    saleItem.complimentedBy = null;
    saleItem.complimentReason = null;
    saleItem.unitPrice = saleItem.originalUnitPrice;
    saleItem.vat = saleItem.originalVat;

    saleItem.originalUnitPrice = 0;
    saleItem.originalVat = 0;

    saleItem.saleItems.forEach (childSaleItem =>
    {
        this.revertItemAsCompliment(childSaleItem);
    });
}

module.exports.retrieveItemDiscount = function(sale, saleItem)
{
    var itemDiscounts = sale.discounts.filter(d => stringUtil.areStringSame(d.saleItemId, saleItem.id));
    if (itemDiscounts.length <= 0)
        return null;

    return itemDiscounts[0];
}

module.exports.formatSaleItemCaption = function (saleItem)
{
    if (saleItem.quantity <= 1 || saleItem.unitPrice <= 0 || !localizationUtils.doPrintUnitPriceInSaleReceipt())
        return saleItem.caption;

    return `${saleItem.caption}  (@ ${formatter.convertToCurrencyFormat(saleItem.unitPrice)})`;
}

module.exports.isTodaysBusinessDateSale = function (sale)
{
    let utcDateTime = sale.dateTime;
    if (stringUtil.isStringNullOrEmpty(utcDateTime))
        utcDateTime = dateUtil.getNow();

    return businessDateUtil.getPropertyBusinessDateFromUtcDateTime(utcDateTime) == businessDateUtil.getTodayBusinessDate();
}

module.exports.isSaleOfProperty = function (sale)
{
    let storefront = storefrontUtility.getStorefrontById(sale.storefrontId);
    return storefrontUtility.getStorefrontVenueCode(storefront) == constants.VenueCodeProperty;
}

module.exports.getSaleServiceChargePercentage = function (sale)
{
    if(sale.venueCode !== constants.VenueCodeProperty || sale.saleType !== constants.SaleTypeSale)
        return 0;

    let serviceChargePercentage = 0;
    let floatConfiguration = commonUtility.getPropertyFloatConfiguration();

    if (sale.dispatchType == constants.DispatchTypeDineIn && floatConfiguration.dineInServiceCharges != null)
        serviceChargePercentage = floatConfiguration.dineInServiceCharges * 1;
    
    if (sale.dispatchType == constants.DispatchTypeTakeAway && floatConfiguration.takeAwayServiceCharges != null)
        serviceChargePercentage = floatConfiguration.takeAwayServiceCharges * 1;
    
    if (sale.dispatchType == constants.DispatchTypeCollection && floatConfiguration.collectionServiceCharges != null)
        serviceChargePercentage = floatConfiguration.collectionServiceCharges * 1;
    
    if (sale.dispatchType == constants.DispatchTypeDelivery && floatConfiguration.deliveryServiceCharges != null)
        serviceChargePercentage = floatConfiguration.deliveryServiceCharges * 1;
   
    return serviceChargePercentage * 0.01;
}

module.exports.isPropertyDeliverySale = function (sale)
{
    if (sale.dispatchType !== constants.DispatchTypeDelivery)
        return false;

    const operatingConfiguration = commonUtility.getStorefrontById(sale.storefrontId).operatingConfiguration;

    if (operatingConfiguration && operatingConfiguration.propertyHandlesDelivery)
        return true;

    return false;
} 
